import React from "react";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _450px,
} from "../../utils/mediaBreakpoints";

const EthicalAIAndResponsibleInnovation = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div className="row " style={{ background: "#000000" }}>
        <div className="container contwidth h-100">
          <div className="row h-100">
            <div
              className={`col-12 col-sm-3 ${_768 ? "" : "pe-5"} ${_576 ? "" : "vh-100"
                }`}
              style={{
                padding: _450
                  ? "0" // "4rem 5rem 4rem 0rem"
                  : _768
                    ? "0"
                    : // ? "0rem 5.5rem 0rem 0rem"
                    _1200
                      ? "1.7rem 0rem"
                      : _1700
                        ? "0.8rem 0rem"
                        : _1800
                          ? "1rem 0rem"
                          : "1rem 0rem",
              }}
            >
              <div className="d-flex flex-row flex-sm-column flex-wrap justify-content-center align-items-sm-start gap-2 h-100 pt-5 pt-sm-0">
                {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))}
                {/* {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))}
                {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))}
                {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))}
                {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))}
                {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))}
                {data?.icons?.map((obj, idx) => (
                  <React.Fragment key={idx}>
                    <IconViewer data={obj?.url} />
                  </React.Fragment>
                ))} */}
              </div>
            </div>

            <div
              className="col-12 col-sm-9"
              style={{ paddingLeft: _576 ? "0rem" : _768 ? "2rem" : "" }}
            >
              <div
                className={`d-flex flex-column justify-content-center align-items-center `}
                style={{
                  padding: _576
                    ? "5rem 0rem"
                    : _768
                      ? "7rem 0rem"
                      : _992
                        ? "8rem 0rem"
                        : _1200
                          ? "9rem 0rem"
                          : "10rem 0rem",
                  gap: _576
                    ? "2rem"
                    : _768
                      ? "2.5rem"
                      : _1200
                        ? "3rem"
                        : _1400
                          ? "4rem"
                          : "5rem",
                }}
              >
                {data?.heading &&
                  (() => {
                    const phrase1 = "Ethical";
                    const phrase2 = "Responsible";
                    return (
                      <p
                        className="fw900 text-white "
                        style={{
                          fontSize: _450
                            ? "18px"
                            : _576
                              ? "20px"
                              : _768
                                ? "25px"
                                : _992
                                  ? "30px"
                                  : _1200
                                    ? "30px"
                                    : _1400
                                      ? "35px"
                                      : _1600
                                        ? "45px"
                                        : _1700
                                          ? "50px"
                                          : _1800
                                            ? "60px"
                                            : "60px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: data?.heading
                            ?.split("\n")
                            ?.join("<br/>")
                            ?.replace(
                              phrase1,
                              `<span style="color: #459EFF">${phrase1}</span>`
                            )
                            ?.replace(
                              phrase2,
                              `<span style="color: #459EFF">${phrase2}</span>`
                            ),
                        }}
                      />
                    );
                  })()}
                <div className="list">
                  {React.createElement(
                    data?.bullets?.[0]?.format === "unordered" ? "ul" : "ol",
                    {
                      style: {
                        fontSize: _450
                          ? "14px"
                          : _576
                            ? "14px"
                            : _768
                              ? "15px"
                              : _992
                                ? "15px"
                                : _1200
                                  ? "15px"
                                  : _1400
                                    ? "17px"
                                    : _1600
                                      ? "19px"
                                      : _1700
                                        ? "22px"
                                        : _1800
                                          ? "22px"
                                          : "22px",
                        // lineHeight: _450
                        //   ? "9px"
                        //   : _576
                        //   ? "10px"
                        //   : _768
                        //   ? "11px"
                        //   : _992
                        //   ? "15px"
                        //   : _1200
                        //   ? "15px"
                        //   : _1400
                        //   ? "17px"
                        //   : _1600
                        //   ? "19px"
                        //   : _1700
                        //   ? "22px"
                        //   : _1800
                        //   ? "36px"
                        //   : "36px",
                        padding: _450
                          ? "0rem 0rem 0rem 0.5rem"
                          : _576
                            ? "0rem 0rem 0rem 1rem"
                            : _1400
                              ? "0rem 0rem 0rem 1.5rem"
                              : _1600
                                ? "0rem 0rem 0rem 2rem"
                                : _1700
                                  ? "0rem 0rem 0rem 2.3rem"
                                  : _1800
                                    ? "0rem 0rem 0rem 2.5rem"
                                    : "0rem 0rem 0rem 2.5rem",
                      },
                      className: `fw400 text-white d-flex flex-column gap-4 m-0 align-self-start lh-sm`,
                    },
                    data?.bullets?.map((item, index) => (
                      <ListView key={index} data={item} />
                    ))
                  )}
                </div>

                <p
                  className="fw700 text-white text-center lh-sm p-0"
                  style={{
                    padding: _450
                      ? "0rem 2rem 0rem 0rem"
                      : _576
                        ? "0rem 1rem 0rem 0rem"
                        : _768
                          ? "0rem 4rem 0rem 0rem"
                          : _992
                            ? "0rem 8rem 0rem 0rem"
                            : _1200
                              ? "0rem 10rem 0rem 0rem"
                              : _1400
                                ? "0rem 12rem 0rem 0rem"
                                : _1600
                                  ? "0rem 7rem 0 2.5rem"
                                  : _1700
                                    ? "0rem 9rem 0 3rem"
                                    : _1800
                                      ? "0rem 11rem 0 4rem"
                                      : "0rem 11rem 0 5rem",
                    fontSize: _450
                      ? "18px"
                      : _576
                        ? "18px"
                        : _768
                          ? "18px"
                          : _992
                            ? "20px"
                            : _1200
                              ? "22px"
                              : _1400
                                ? "25px"
                                : _1600
                                  ? "30px"
                                  : _1700
                                    ? "35px"
                                    : _1800
                                      ? "40px"
                                      : "40px",
                    // lineHeight: _450
                    //   ? "0.8rem"
                    //   : _576
                    //   ? "1.1rem"
                    //   : _768
                    //   ? "1.5rem"
                    //   : _992
                    //   ? "1.4rem"
                    //   : _1200
                    //   ? "1.9rem"
                    //   : _1400
                    //   ? "2.1rem"
                    //   : _1600
                    //   ? "2.2rem"
                    //   : _1700
                    //   ? "2.5rem"
                    //   : _1800
                    //   ? "2.8rem"
                    //   : "2.8rem",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: _576
                      ? data?.sub_heading
                        ?.split("\n")
                        ?.map((line, index) => {
                          const color = index === 0 ? "#FFFFFF" : "#459EFF";
                          const cleanLine = line.replace(/^#\s*/, "");
                          return `<span style="color: ${color}">${cleanLine}</span>`;
                        })
                        ?.join(" ")
                      : data?.sub_heading
                        ?.split("\n")
                        ?.map((line, index) => {
                          const color = index === 0 ? "#FFFFFF" : "#459EFF";
                          const cleanLine = line.replace(/^#\s*/, "");
                          return `<span style="color: ${color}">${cleanLine}</span>`;
                        })
                        ?.join("<br/>"),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const IconViewer = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center gx-0"
        style={{
          width: _450
            ? "50px"
            : _768
              ? "70px"
              : _1200
                ? "75px"
                : _1400
                  ? "90px"
                  : _1600
                    ? "100px"
                    : _1700
                      ? "110px"
                      : _1800
                        ? "130px"
                        : "140px",
          height: _450
            ? "80px"
            : _1200
              ? "110px"
              : _1400
                ? "130px"
                : _1600
                  ? "140px"
                  : _1700
                    ? "160px"
                    : _1800
                      ? "170px"
                      : "190px",
          borderRadius: "192px",
          // background: "#FFFFFF",
        }}
      >
        <img
          src={`${baseUrl}${data}`}
          alt=""
          // width={
          //   _450
          //     ? 20
          //     : _576
          //       ? 35
          //       : _768
          //         ? 35
          //         : _992
          //           ? 40
          //           : _1200
          //             ? 40
          //             : _1400
          //               ? 45
          //               : _1600
          //                 ? 55
          //                 : _1700
          //                   ? 60
          //                   : _1800
          //                     ? 74
          //                     : 74
          // }

          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </div>
    </>
  );
};

const ListView = ({ data }) => {
  return (
    <>
      <li>{data?.children[0]?.children[0]?.text}</li>
    </>
  );
};

export default EthicalAIAndResponsibleInnovation;
